import { render, staticRenderFns } from "./CustomeForm.vue?vue&type=template&id=5eb936d9"
import script from "./CustomeForm.vue?vue&type=script&lang=js"
export * from "./CustomeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports